import { ReactElement } from 'react';

import { Container } from '@/common/ui/containers/Container/Container';
import { Button } from '@/common/ui';
import { ReviewsCard } from '@/common/ui';
import {
    ActivityReviews,
    ActivityReviewsSubTitle,
    ActivityReviewsTitle,
    ReviewCardContainer,
} from '@/screens/ActivityPage/ui/ActivityPage.styles';
import { IReview } from '@/entities/Activity/domain/Review.domain';

interface VActivityReviewsProps {
    reviews: IReview[];
    showMore: () => void;
}

export const VActivityReviews = ({ reviews, showMore }: VActivityReviewsProps): ReactElement => {
    const list = reviews || [];

    return (
        <Container data-test-id="Details_reviews">
            {list.length > 0 && (
                <ActivityReviews>
                    <ActivityReviewsTitle>Verified Traveler Reviews</ActivityReviewsTitle>
                    <ActivityReviewsSubTitle>Provided by Viator</ActivityReviewsSubTitle>
                    <ReviewCardContainer>
                        {list.map((review) => {
                            return <ReviewsCard key={review.id} review={review} />;
                        })}
                    </ReviewCardContainer>
                    {list.length > 2 && (
                        <Button variant={'primary'} onClick={showMore}>
                            More reviews
                        </Button>
                    )}
                </ActivityReviews>
            )}
        </Container>
    );
};

export default VActivityReviews;
